import getUserCountry from "../libs/getUserCountry";
import { compose, lifecycle, withHandlers, withState, withProps } from "recompose";

export const withUserCountry = compose(
  withState("country", "setCountry", null),
  lifecycle({
    componentDidMount() {
      getUserCountry().then(data => {
        if (data && data.data) {
          this.props.setCountry(data.data.userCountry);
        }
      });
    },
  })
);

export default withUserCountry;
